var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bl-tooltip-component" },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm.$slots.tooltip || _vm.tooltip
        ? _c(
            "div",
            {
              staticClass: "bl-tooltip",
              class: ["bl-tooltip-drop-" + _vm.drop]
            },
            [
              _vm.$slots.tooltip
                ? _c(
                    "div",
                    {
                      staticClass:
                        "text-xs font-normal leading-relaxed tracking-wide text-center text-pure-white"
                    },
                    [_vm._t("tooltip")],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.tooltip
                ? _c("BlTextBody3", {
                    staticClass: "bl-tooltip-text",
                    attrs: { text: _vm.tooltip }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1296104e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1296104e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlTooltip.vue
// module id = null
// module chunks = 